let checkInterval = 0;
const interval = setInterval(() => {
  const cartItems = document.querySelectorAll('[id^="CartItem-"]');
  if (cartItems.length > 0) {
    clearInterval(interval);

    $('[data-item-quantity-plus]').click(function(event) {
      event.preventDefault();
      const input = $(this)
        .parent()
        .find('input');
      const val = parseInt(input.val(), 10) + 1;
      input.attr('value', val);
      input.val(val);
    });

    $('[data-item-quantity-minus]').click(function(event) {
      event.preventDefault();

      const input = $(this)
        .parent()
        .find('input');

      let val = parseInt(input.val(), 10);
      if (val > 0) {
        val -= 1;
        input.attr('value', val);
        input.val(val);
      }
    });
  }
  if (++checkInterval == 200) {
    clearInterval(interval);
  }
}, 100);
